import React from 'react';
import { Department } from '../types/app';
import './FilterBar.css';

interface FilterBarProps {
  departments: Department[];
  selectedDepartmentId: number | null;
  searchQuery: string;
  onDepartmentChange: (departmentId: number | null) => void;
  onSearchChange: (query: string) => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  departments,
  selectedDepartmentId,
  searchQuery,
  onDepartmentChange,
  onSearchChange,
}) => {
  const handleDepartmentChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onDepartmentChange(value === '' ? null : parseInt(value, 10));
  };

  return (
    <div className="filter-bar">
      <div className="filter-search">
        <input
          type="text"
          placeholder="Search apps..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="search-input"
        />
      </div>
      <div className="filter-department">
        <select
          value={selectedDepartmentId ?? ''}
          onChange={handleDepartmentChange}
          className="department-select"
        >
          <option value="">All Departments</option>
          {departments.map((dept) => (
            <option key={dept.id} value={dept.id}>
              {dept.name} {dept.appCount !== undefined && `(${dept.appCount})`}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};
